import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchProfile, updateProfile, deleteProfile } from '../../services/api';
import Sidebar from './Sidebar'; // import your Sidebar component

const Profile = () => {
    const [profile, setProfile] = useState(null);
    const [profilePicture, setProfilePicture] = useState(null);
    const [error, setError] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);

    const [sidebarCollapsed, setSidebarCollapsed] = useState(
        () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
    );

    useEffect(() => {
        localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
    }, [sidebarCollapsed]);

    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();

    useEffect(() => {
        const loadProfile = async () => {
            try {
                const profileData = await fetchProfile(token);
                setProfile(profileData);
                setProfilePicture(profileData.profile_picture);
            } catch (err) {
                setError(err.detail || 'Error fetching profile');
                console.error('Error fetching profile:', err);
            }
        };
        loadProfile();
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const formData = new FormData();

        if (profilePicture) {
            const fileExtension = profilePicture.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];

            if (allowedExtensions.includes(fileExtension)) {
                formData.append('profile_picture', profilePicture);
            } else {
                setError('Invalid file type. Allowed types are: jpg, jpeg, png, webp.');
                return;
            }
        } else {
            formData.append('profile_picture', new File([], ''));
        }

        try {
            const updatedProfile = await updateProfile(formData, token);
            setProfile((prev) => ({ ...prev, ...updatedProfile }));
        } catch (err) {
            setError('Error updating profile');
            console.error(err);
        }
    };

    const confirmDeleteProfile = () => setConfirmDelete(true);

    const handleDelete = async () => {
        if (confirmDelete) {
            try {
                await deleteProfile(token);
                localStorage.removeItem('authToken');
                navigate('/');
            } catch (err) {
                setError('Error deleting profile');
                console.error(err);
            }
        }
    };

    const handleLogout = () => navigate('/logout');

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) setProfilePicture(file);
    };

    const handleResetImage = () => {
        setProfilePicture(null);
        setShowImageModal(true);
    };

    return (
        <div className='dashboard-background-profile'>
            <div className='container-fluid'>
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <div className="d-flex">
                    {/* Sidebar component */}
                    <Sidebar userProfile={profile}
                        isCollapsed={sidebarCollapsed}
                        setIsCollapsed={setSidebarCollapsed}
                    />

                    {/* Main Content */}
                    <main className="flex-grow-1 px-4"
                        style={{
                            minHeight: '80vh',
                            marginLeft: sidebarCollapsed ? '60px' : '220px'
                        }}>
                        <div className="text-center mb-4 d-flex align-items-center justify-content-center">
                            <img
                                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                                alt="Logo"
                                style={{ width: '100px', height: '100px', marginRight: '0px' }}
                            />
                            <h1 className="fw-bold d-inline mb-0">Jessster Account</h1>
                        </div>

                        {/* Profile Section */}
                        <div className="text-center mb-4 d-flex flex-column align-items-center" style={{ flex: 1 }}>
                            <div
                                className="position-relative"
                                style={{
                                    width: '120px',
                                    height: '120px',
                                    marginBottom: '10px',
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                                }}
                            >
                                <img
                                    src={profilePicture || "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736169445/cartoonish_animated_black_and_white_profile_image_of_a_jester_facing_forward_ixolqj.jpg"}
                                    alt="Profile"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                                <button
                                    className="btn position-absolute top-0 end-0 p-2"
                                    style={{
                                        fontSize: '1.2rem',
                                        backgroundColor: 'rgba(0,0,0,0.6)',
                                        borderRadius: '50%',
                                        transition: 'transform 0.2s',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    onClick={() => setShowImageModal(true)}
                                >
                                    <i className="fas fa-pencil-alt text-white"></i>
                                </button>
                            </div>
                            <h1 className="fw-bold mb-0">Profile</h1>
                        </div>


                        {/* User Information */}
                        <div
                            className="text-center mb-4 d-flex flex-column align-items-center"
                            style={{ gap: '10px' }}
                        >
                            <div
                                className="p-3 border rounded shadow-sm d-flex align-items-center justify-content-center gap-2"
                                style={{ maxWidth: '400px', width: '100%' }} // contained width
                            >
                                <i className="fas fa-user-circle text-primary"></i>
                                <span><strong>Username:</strong> {profile?.username}</span>
                            </div>

                            <div
                                className="p-3 border rounded shadow-sm d-flex align-items-center justify-content-center gap-2"
                                style={{ maxWidth: '400px', width: '100%' }} // contained width
                            >
                                <i className="fas fa-paper-plane text-success"></i>
                                <span><strong>Email:</strong> {profile?.email || 'No email available'}</span>
                            </div>
                        </div>

                        {/* Delete Profile Button */}
                        <div className="d-flex justify-content-center mt-4">
                            <div
                                className="p-3 border rounded shadow-sm text-center"
                                style={{ maxWidth: '400px', backgroundColor: '#fff3f3', borderColor: '#f5c6cb' }}
                            >
                                <div className="d-flex flex-column align-items-center gap-2">
                                    <i className="fas fa-exclamation-triangle text-danger" style={{ fontSize: '2rem' }}></i>
                                    <p className="mb-2 fw-semibold text-danger">
                                        This action is <strong>permanent</strong> and cannot be undone.
                                    </p>
                                    <button
                                        onClick={confirmDeleteProfile}
                                        className="btn btn-danger fw-bold"
                                        style={{
                                            padding: '0.75rem 1.5rem',
                                            fontSize: '1rem',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 12px rgba(220,53,69,0.3)',
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 6px 18px rgba(220,53,69,0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(220,53,69,0.3)';
                                        }}
                                    >
                                        Delete Profile
                                    </button>
                                </div>
                            </div>
                        </div>


                        {/* Profile Image Modal */}
                        {showImageModal && (
                            <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }} aria-hidden="false">
                                <div className="modal-dialog">
                                    <div className="modal-content text-center" style={{ backgroundColor: '#F9FAFC' }}>
                                        <div className="modal-header">
                                            <h5 className="modal-title fw-bold" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                                                Update Profile Picture
                                            </h5>
                                            <button type="button" className="btn-close" onClick={() => setShowImageModal(false)} aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <form
                                                onSubmit={(e) => {
                                                    handleSubmit(e);
                                                    setShowImageModal(false);
                                                }}
                                            >
                                                <div className="mb-2">
                                                    <input
                                                        type="file"
                                                        onChange={handleImageUpload}
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="mb-2">
                                                    <button type="button" className="btn btn-danger mt-3 fw-bold" onClick={handleResetImage}>
                                                        Reset to Default image
                                                    </button>
                                                </div>
                                                <div className="modal-footer d-flex justify-content-between">
                                                    <button type="button" className="btn btn-secondary fw-bold" onClick={() => setShowImageModal(false)}>
                                                        Cancel
                                                    </button>
                                                    <button type="submit" className="btn btn-primary fw-bold">
                                                        Save
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Delete Profile Confirmation */}
                        {confirmDelete && (
                            <div className="modal fade show" style={{ display: 'block' }} aria-hidden="false">
                                <div className="modal-dialog">
                                    <div className="modal-content" style={{ backgroundColor: '#F9FAFC' }}>
                                        <div className="modal-header">
                                            <h5 className="modal-title fw-bold" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>Confirm Deletion</h5>
                                            <button type="button" className="btn-close" onClick={() => setConfirmDelete(false)} aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body text-center">
                                            <p>Are you sure you want to delete your profile?</p>
                                            <p>This action is not reversible!</p>
                                        </div>
                                        <div className="modal-footer d-flex justify-content-between">
                                            <button type="button" className="btn btn-secondary" onClick={() => setConfirmDelete(false)}>Cancel</button>
                                            <button type="button" className="btn btn-danger" onClick={handleDelete}>Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Profile;
